export const documentsConstants = {
  ZIP_TYPE_FILE: 'AllDocumentsCompacted',
}
